/**
 * 配置项
 */
const state = {
  //一张图坐标
  initExtent: [
    116.30,
    26.52,
    116.40,
    26.62
  ],
  title: "景德镇昌南湖国家湿地公园", // 页面标题
  needWeChatCode: true, // 是否需要显示微信二维码
  needAppCode: true, // 是否需要显示app二维码
  videoTitle: "景德镇昌南湖国家湿地公园", // 预警发布页面湿地公园名称
  isDevelopmentEnvironment: false, // 是否为开发环境,开发时请改为true,打包时请改为false(动态改变湿地一张图、视频监控、巡护展示的路径)
  projectName: "jdzcnh", // 部署后的项目名,如果没有则为空
  identification:'jdzcnh',//添加各个湿地唯一标识
  //关于我们地图数据
  deviceSerialItem: ["240696640"] 
}; 
export default {
  state
};



// WEBPACK FOOTER //
// ./src/store/modules/configuration.js